export enum OtSegmentInstanceStatusRequirement {
  MustBeOpen = 'MUSTBEOPEN',
  CanBeOpenOrClosed = 'CANBEOPENORCLOSED',
  MustBeClosed = 'MUSTBECLOSED',
}
